/**
 * Model for a single entry in the quicknav table of contents.
 */
var QuickNavTocEntry = /** @class */ (function () {
    function QuickNavTocEntry() {
        /**
         * Property that determines whether to show the TOC entry. This may be a boolean, or a function that returns a
         * boolean.
         */
        this.visible = true;
    }
    return QuickNavTocEntry;
}());
export { QuickNavTocEntry };
/**
 * Container model for quicknav table of contents.
 */
var QuickNavToc = /** @class */ (function () {
    function QuickNavToc(id, entries) {
        this.scrollSpyId = id;
        this.entries = entries;
    }
    Object.defineProperty(QuickNavToc.prototype, "visibleEntries", {
        /**
         * Returns only the TOC entries that are visible
         * @returns {Array<QuickNavTocEntry>}
         */
        get: function () {
            return this.entries.filter(function (e) {
                if (typeof e.visible === 'function') {
                    return e.visible();
                }
                return e.visible;
            });
        },
        enumerable: true,
        configurable: true
    });
    return QuickNavToc;
}());
export { QuickNavToc };
